export function getVideoEventId(video) {
  return video?.event_id ?? video?.event?.id;
}

export function filterCompetitionVideos(videos, activeEventId, categoryFilter = "") {
  return (videos || []).filter((v) => {
    if (
      activeEventId != null &&
      String(getVideoEventId(v)) !== String(activeEventId)
    ) {
      return false;
    }
    if (categoryFilter) {
      const cat = v.category ?? v.contestant?.category;
      if (cat !== categoryFilter) return false;
    }
    return true;
  });
}

export function formatOrdinal(n) {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;
  const mod10 = n % 10;
  if (mod10 === 1) return `${n}st`;
  if (mod10 === 2) return `${n}nd`;
  if (mod10 === 3) return `${n}rd`;
  return `${n}th`;
}

export const MAX_VIDEO_RANK_DISPLAY = 5;

export function rankCompetitionVideos(videos, activeEventId, categoryFilter = "") {
  const filtered = filterCompetitionVideos(videos, activeEventId, categoryFilter);
  return [...filtered]
    .sort((a, b) => {
      const av = a.voteCount ?? a.vote_count ?? 0;
      const bv = b.voteCount ?? b.vote_count ?? 0;
      if (bv !== av) return bv - av;
      return String(a.id).localeCompare(String(b.id));
    })
    .map((v, i) => {
      const rank = i + 1;
      return {
        ...v,
        voteCount: v.voteCount ?? v.vote_count ?? 0,
        rank,
        rankLabel: rank <= MAX_VIDEO_RANK_DISPLAY ? formatOrdinal(rank) : "",
      };
    });
}
